
// Do not change it IDs of the projects

export default [
        {
        id: 1,
        title: "Masters Thesis",
        summary: "Extrinsic Alignment of FMCW Radar with Inertial and Visual Sensors for Multisensor Systems",
        pageLink: "/projMastersThesis",
        description: 

        "Modern autonomous and robotic systems rely on multiple sensors working together- cameras, radars, and IMUs, each with\
        its own strengths and limitations. For them to work reliably, these sensors need to be accurately aligned with each\
        other- both spatially and temporally. In my thesis, I worked on the spatial alignment or calibration of these sensors, \
        specifically an FMCW radar paired with an IMU and an RGB camera, a combination that is less explored compared to more \
        conventional camera-LiDAR setups. For the radar-IMU pair, I proposed two approaches: a target-based method using a single reflector \
        and relative IMU pose measurements, and a targetless method that leverages ego-velocity alignment, which is useful for online \
        deployment without artificial markers. For the radar-camera pair, I implemented a calibration method that detects shared \
        targets across both sensor modalities. All methods were validated through simulation and real-world experiments on a \
        custom 3D-printed sensor rig, built from scratch as part of this work. \n \
        PS: In this video, I'm testing the point cloud captured by the FMCW radar.",
        
        
        // "In my masters thesis, I worked on the extrinsic calibration of a frequency-modulated continuous wave (FMCW) radar with inertial measurement units (IMUs) and RGB cameras. \n\n \
        // For the radar-IMU sensor pair, we propose two approaches: (i) calibration using a single target and relative IMU pose measurements, (ii) target-less calibration using ego-velocity measurements. \n\n \
        // In addition to this, we implement a calibration method for the radar-camera pair by detecting shared targets in both the sensor’s modalities. \n\n \
        // The proposed methods are validated through simulation and real-world experiments on a custom-designed, 3Dprinted sensor rig. \n\n \
        // We present the results for both simulated and real-world data. The results obtained demonstrate the effectiveness of the proposed approaches",
        bullets: "Extrinsic calibration of sensor pairs with different techniques ; Development of a calibration tool in python ",
        exe: 1,
        githubLink : "",
        downloadLink: "",
        downloadName: "",
        liveDemoLink: "https://hdl.handle.net/20.500.14718/44811",
        coverImg: "",
    },

    {
        id: 2,
        title: "Cross platform C++ library",
        summary: "A cross platform C++ library for real time object detection and localization",
        pageLink: "/projObjDet",
        description: "Designed and developed a cross-platform C++ library for an object detection pipeline. The library is implemented \
        to deliver optimized performance on intel devices (CPUs and integrated GPUs, using openVINO) and NVIDIA GPUs (Using TensorRT)  \n\n\
        The architecture of the lib is designed using the PImpl technique, which abstracts away the implementational details and the user interface \
        is minimalistic. The encrypted model is loaded directly in the memory at runtime \n\n \
        With this, we got the absolute frame processing time of the object detection and localization solution down by around 80% (55 ms) and\
        apparent time by 95% (15ms), as compared to the previous implementation of the same in python (300ms). \
        Kudos to Skylark Labs for giving me this project! \n\nKey highlights:",
        bullets: "Cross platform C++ library ; Optimized for intel CPUs and nvidia GPUs; Efficient design using PImpl technique ; \
        Achieved 90% reduction of runtime from previous implementation of \
        the same pipeline ",
        githubLink : "",
        downloadLink: "",
        downloadName: "",
        liveDemoLink: "",
        coverImg: "",
    }, 
    {
        id: 3,
        title: "OpenGL app",
        summary: "A C++ opengl app, with implementation of basic aspects of graphics programming ",
        pageLink: "/proj_opengl",
        description: "This is a basic C++ opengl application, in which cubes are rendered with textures mapped on each side of the cube, in a 3D world \n\n \
        The '3D world' is just a solid purple color coordinate system for now ( it shall be updated in future with an actual scene).  \
        Camera motion is also added in this coordinate system and the user can 'look' around using mouse and move around using W,A,S,D keys. \
        The application demonstrates implementation of a basic opengl window creation, usage of shaders, textures and camera setup in openGL \n\n \
        The application can be downloaded and used right away. Just download the zip folder, extract it and run the .exe file \n\n \
        Usage:-",
        bullets: "To navigate in the coordinate system: W A S D keys ; To 'look around'- Mouse movement ;  To close the exe: esc key",
        exe: 1,
        githubLink : "",
        downloadLink: "/downloads/opengl_app.zip",
        downloadName: "openglApp.zip",
        liveDemoLink: "",
        coverImg: "",
    },

    {
        id: 4,
        title: "NASA space apps challenge",
        summary: "Participated in the NASA space apps challenge 2024 and qualified from Ottawa ",
        pageLink: "/projSpaceApps",
        description: "Participated in the NASA Space Apps Challenge 2024, which was a 2 day hackathon conducted on 2nd - 3rd Oct. We built an orrery web app \
        as a part of this challenge using javascript and specifically, using Three.js library. \n\n \
        Our submission qualified from Ottawa region and we competed at the global level (unfortunately, we didn't win that).   \
        Details of this challenge and our official submission can be found in the links below.  \n \n \
        Here is a small demo video which was a part of our submission. \nPS- The voice in the video is not mine  \n\n \
        Key Highlights:" ,
        bullets: "Qualified from Ottawa region ; A 3D web app using Three.js ; Accurate mapping of orbital data using keplarian parameters",
        githubLink : "https://github.com/Divyam04/Repositorerry",
        downloadLink: "",
        downloadName: "",
        liveDemoLink: "https://tarek-sallam.github.io/Repositorerry/",
        coverImg: "",
    },

    {
        id: 5,
        title: "Robotic Arm",
        summary: "Undergrad final year project- A robotic arm which detects and picks an object",
        pageLink: "/projRoboArm",
        description: "A 2 DOF robotic arm built using a Raspberry Pi and camera. The onboard camera detects the object in front of the arm, \
        evaluates the distance after which the arm picks up the object. Unfortunately, this is the only video I have after which \
        this arm broke into 2 pieces on the presentation day, so kindly ignore the clutter in the video :) \
        \n\n Key Highlights: ",
        bullets: "Pulse width modulation for accurate servo motor angle control; Inverse kinematics to evaluate the angles of each link of the arm  ; \
        Very basic color based object detection and \
         distance estimation using openCV ; \
        Implementation is in python ; Cool spray paint on the body of the arm! ",
        githubLink : "",
        downloadLink: "",
        downloadName: "",
        liveDemoLink: "",
        coverImg: "",
    },

    {
        id: 6,
        title: "Fourier Draw",
        summary: "A javascript web app visualizing the Fourier Series of a rectangular wave. ",
        pageLink: "/projFourierDraw",
        description: "A Javascript web app to visualize the Fourier Series of a rectangular wave in action \n\n  \
        The number of circles represent the number of coefficients selcted from the series and their rotation speed  \
        represents the coefficient itself. \
        As the number of coefficients ( or the no. of circles) increases, the approximation gets closer and closer  \
        to the rectangular wave. \n\n\
        This project serves no purpose in demonstrating any particular skill, instead it is just an admiration for one of the \
        greatest minds to have ever lived. If this isn't the coolest thing then I dont know what is  \
        \n\n Key Highlights: ",
        bullets: "Visualization of Fourier Series; Two.js / Javascript  ",
        githubLink : "https://github.com/Divyam04/fourierDraw",
        downloadLink: "",
        downloadName: "",
        liveDemoLink: "https://divyam04.github.io/fourierDraw/",
        coverImg: "",
    },

    {
        id: 7,
        title: "This website",
        summary: "Just a quick note that my website is built with React and styled with CSS. \n \
        PS: This is not Vibe Coded",
        pageLink: "",
        description: "",
        bullets: "",
        githubLink : "",
        downloadLink: "",
        downloadName: "",
        liveDemoLink: "",
        coverImg: "",
    },

    
    // {
    //     id: 8,
    //     title: "Depth estimation of car ",
    //     summary: "3D machine vision class project",
    //     description: "",
    //     pageLink: "",
    //     description: "",
    //     bullets: "",
    //     githubLink : "",
    //     downloadLink: "",
    //     downloadName: "",
    //     liveDemoLink: "",
    //     coverImg: "",
    // },
    
]